<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="section005">
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<p class="fmtitle"><span class="right_1" epub:type="pagebreak" id="page_vii" title="vii">CONTENTS</span></p>
<div class="pseudo_margin_2"></div>
<div class="pseudo_margin_1"></div>
<ul>
<li><span href="#/text/title_page" title="Link target outside of Sample">Title Page</span></li>
<li><span href="#/text/Copyright" title="Link target outside of Sample">Copyright</span></li>
</ul>
<div class="pseudo_margin_2"></div>
<div class="centered_text">
<p><span href="#/text/Part01" title="Link target outside of Sample">ONE</span></p>
<div class="pseudo_margin_1"></div>
</div>
<ol>
<li><span href="#/text/Chapter01#ch1" title="Link target outside of Sample"><em>When I Cannot Sleep—Day Six—a Letter</em></span></li>
<li><span href="#/text/Chapter02#ch2" title="Link target outside of Sample"><em>To Be a God</em></span></li>
<li><span href="#/text/Chapter03#ch3" title="Link target outside of Sample"><em>My Mother Takes the Stand</em></span></li>
<li><span href="#/text/Chapter04#ch4" title="Link target outside of Sample"><em>On the Mysterious Disappearance of Fortunetellers</em></span></li>
<li><span href="#/text/Chapter05#ch5" title="Link target outside of Sample"><em>Self-Portrait in Which I Resemble the Man next to Me</em></span></li>
<li><span href="#/text/Chapter06#ch6" title="Link target outside of Sample"><em>Nobody</em></span></li>
<li><span href="#/text/Chapter07#ch7" title="Link target outside of Sample"><em>The Jukebox That Ended the World Twice</em></span></li>
<li><span href="#/text/Chapter08#ch8" title="Link target outside of Sample"><em>Proxy Baptism</em></span></li>
<li><span href="#/text/Chapter09#ch9" title="Link target outside of Sample"><em>The Opera Singer</em></span></li>
</ol>
<div class="pseudo_margin_2"></div>
<div class="centered_text">
<p><span href="#/text/Part02" title="Link target outside of Sample">TWO</span></p>
<div class="pseudo_margin_1"></div>
</div>
<ol>
<li><span href="#/text/Chapter10#ch10" title="Link target outside of Sample"><em>The Banquet</em></span></li>
<li><span href="#/text/Chapter11#ch11" title="Link target outside of Sample"><em>The Mistake</em></span></li>
<li><span href="#/text/Chapter12#ch12" title="Link target outside of Sample"><em>Illness</em></span></li>
<li><span href="#/text/Chapter13#ch13" title="Link target outside of Sample"><em>Idiom of the Entrepreneur</em></span></li>
<li><span href="#/text/Chapter14#ch14" title="Link target outside of Sample"><em>Then After</em></span></li>
<li><span href="#/text/Chapter15#ch15" title="Link target outside of Sample"><em>Election Day</em></span></li>
<li><span href="#/text/Chapter16#ch16" title="Link target outside of Sample"><em>Two Surgeons</em></span></li>
<li><span href="#/text/Chapter17#ch17" title="Link target outside of Sample"><em>The Diner</em></span></li>
<li><span href="#/text/Chapter18#ch18" title="Link target outside of Sample"><em>Player Piano</em></span></li>
<li><span href="#/text/Chapter19#ch19" title="Link target outside of Sample"><em>When the Buskers Leave Town for Good</em></span></li>
<li><span href="#/text/Chapter20#ch20" title="Link target outside of Sample"><em>The Kind of Life I Always Wanted</em></span></li>
<li><span href="#/text/Chapter21#ch21" title="Link target outside of Sample"><em>The Door</em></span></li>
</ol>
<div class="pseudo_margin_2"></div>
<div class="centered_text">
<p><span href="#/text/Part03" title="Link target outside of Sample">THREE</span></p>
<div class="pseudo_margin_1"></div>
</div>
<ol>
<li><span href="#/text/Chapter22#ch22" title="Link target outside of Sample"><em>Field Kabuki</em></span></li>
<li><span href="#/text/Chapter23#ch23" title="Link target outside of Sample"><em>The Game</em></span></li>
<li><span href="#/text/Chapter24#ch24" title="Link target outside of Sample"><em>The Very Very Important Benefactor</em></span></li>
<li><span href="#/text/Chapter25#ch25" title="Link target outside of Sample"><em>The Story as It Was Told to Me</em></span></li>
<li><span href="#/text/Chapter26#ch26" title="Link target outside of Sample"><em>The Portrait of What Is Not There</em></span></li>
<li><span href="#/text/Chapter27#ch27" title="Link target outside of Sample"><em>Habeas Corpus</em></span></li>
<li><span href="#/text/Chapter28#ch28" title="Link target outside of Sample"><em>Nobody</em></span></li>
<li><span href="#/text/Chapter29#ch29" title="Link target outside of Sample"><em>How I Came to Rule the World</em></span></li>
<li><span href="#/text/Chapter30#ch30" title="Link target outside of Sample"><em>As You Left It</em></span></li>
</ol>
<div class="pseudo_margin_2"></div>
<ul>
<li><span href="#/text/Acknowledgments#ack" title="Link target outside of Sample"><em>Acknowledgments</em></span></li>
<li><span href="#/text/Author" title="Link target outside of Sample"><em>About the Author</em></span></li>
</ul>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Toc.vue?120dbd2a